import { css } from 'styled-components'

export const BANNER_BUTTON_COLOR_OVERRIDE_CLASS_NAME = 'banner-button-color-override'
export const BANNER_BUTTON_TEXT_COLOR_VAR = '--banner-button-text-color'
export const BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR = '--banner-button-primary-contrast-color'
const DEFAULT_PRIMARY_CONTRAST_COLOR = '#FFFFFF'

export const createBannerButtonColorVariables = (
  textColor: string,
  primaryContrastColor = DEFAULT_PRIMARY_CONTRAST_COLOR,
) => `
  ${BANNER_BUTTON_TEXT_COLOR_VAR}: ${textColor};
  ${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR}: ${primaryContrastColor};
`

// REBRAND: should this use semantic colours instead of overwriting all the default button styling
export const createBannerButtonColorStyles = (selector: string) => css`
  ${selector}.kind-tertiary {
    --button-internal-default-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-active-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-ring-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-background-color: transparent;
    --button-internal-focus-background-color: transparent;
    --button-internal-active-background-color: transparent;
  }

  ${selector}.kind-secondary {
    --button-internal-default-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-active-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-default-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-active-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-background-color: transparent;
    --button-internal-focus-background-color: transparent;
    --button-internal-active-background-color: transparent;
  }

  ${selector}.kind-primary {
    --button-internal-default-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-default-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-default-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-internal-hover-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-hover-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-internal-focus-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-focus-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-internal-active-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-active-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-internal-active-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
  }
`
